import React, { useRef, useState } from "react";
import PageHeading from "../../components/PageHeading";
import DCard from "../../components/DCard";
import SearchFilter from "../../components/SearchFilter";
import DButton from "../../components/DButton";
import orderServices from "../../services/orders";
import { Spinner } from "@chakra-ui/react";
import { toast } from "react-hot-toast";

const OrderLog = ({ title }) => {
    const orderId = useRef();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const changeHandler = e => {
        orderId.current = e;
    };

    const fetchOrderLog = () => {
        setLoading(true);
        orderServices
            .getOrderLog(orderId.current)
            .then(res => {
                setData(res.data.data);
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setData([]);
                toast.error("لا يوجد معلومات متوفرة");
                setLoading(false);
            });
    };
    return (
        <div>
            <PageHeading>{title}</PageHeading>
            <DCard className={"mb-4"}>
                <div className="mx-auto sm:w-2/4 md:w-1/4">
                    <div className="mb-2">
                        <label
                            htmlFor="search"
                            className=" block mb-2 text-center"
                        >
                            رقم الطلب:
                        </label>
                        <SearchFilter
                            value={orderId.current}
                            changeHandler={changeHandler}
                            id="search"
                        />
                    </div>
                    <DButton
                        disabled={loading}
                        onClick={fetchOrderLog}
                        className="text-white min-w-[100px] mx-auto flex justify-center"
                    >
                        {loading ? <Spinner /> : "ابحث"}
                    </DButton>
                </div>
            </DCard>
            {data.length > 0 && (
                <DCard>
                    {data.map(d => (
                        <div className="bg-light-color mb-4 p-2">
                            <code className="">{JSON.stringify(d)}</code>
                        </div>
                    ))}
                </DCard>
            )}
        </div>
    );
};

export default OrderLog;
